module.exports = __webpack_public_path__ + "static/flags/IM-a6b89a3b2c3691ba01ac892ebcfeb098.gif";